import { render, staticRenderFns } from "./PublishTypeDialog.vue?vue&type=template&id=afa1c020&scoped=true"
import script from "./PublishTypeDialog.vue?vue&type=script&lang=js"
export * from "./PublishTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./PublishTypeDialog.vue?vue&type=style&index=0&id=afa1c020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa1c020",
  null
  
)

export default component.exports